// SPDX-FileCopyrightText: 2026 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { z } from 'zod';

const BannerSeveritySchema = z.enum(['error', 'warning', 'info']).default('info');

const BannerDtoSchema = z.object({
  isDismissable: z.boolean(),
  startDate: z.string(),
  endDate: z.string(),
  title: z.string(),
  info: z.string(),
  severity: BannerSeveritySchema,
});

export type BannerSeverity = z.infer<typeof BannerSeveritySchema>;
export type BannerDto = z.infer<typeof BannerDtoSchema>;

export function parseBanner(object: unknown): BannerDto | null {
  const result = BannerDtoSchema.safeParse(object);
  return result.success ? result.data : null;
}

export function bannerKey(banner: BannerDto): string {
  return `${banner.startDate}|${banner.endDate}|${banner.title}`;
}
